import React from 'react'
import PropTypes from 'prop-types';
import Parent from 'pu-react/components/PriceMatrixCell'

// Overriden to make the quantity either a string or a number
class PriceMatrixCell extends Parent { }

PriceMatrixCell.propTypes = {
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

export default PriceMatrixCell
